export const HOME_ROUTING = [
    {
        path: '/',
        name: 'home',
        redirect: { name: 'package' },
        component: () => import('./Home.vue'),
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Trang chủ' },
        ] },
        children: [],
    },
];
